export default {
  // view
  title: 'Datos de factoring',
  contact: {
    title: 'Contacto de factoring',
    name: 'Nombre comercial',
    document: 'CIF',
    residence: 'Residencia',
    tradeName: 'Razón social',
    address: {
      title: 'Dirección',
      street: 'Calle',
      postalCode: 'Dirección postal',
      town: 'Ciudad',
      city: 'Provincia',
      country: 'País'
    },
    registrationData: {
      title: 'Información de registro',
      book: 'Libro',
      sheet: 'Hoja',
      folio: 'Folio',
      section: 'Sección',
      volume: 'Volumen',
      mercantileRegistry: 'Registro mercantil',
      additionalRegistrationData: 'Información adicional'
    },
    medium: {
      title: 'Datos de contacto',
      phone: 'Teléfono',
      fax: 'Fax',
      web: 'Web',
      email: 'Email',
      name: 'Nombre',
      additionalContactDetails: 'Información adicional'
    }
  },
  payment: {
    title: 'Datos de pago',
    headers: {
      date: 'Fecha',
      amount: 'Cantidad',
      paymentMethod: 'Forma de pago'
    }
  },
  assignmentReference: {
    title: 'Referencias de la cesión',
    name: 'Texto clausula de cesión'
  },
  assignmentDocuments: {
    title: 'Documentos de la cesión',
    headers: {
      documentCharacter: 'N. del documento',
      representationIdentity: 'T. de representación',
      documentType: 'T. de documento'
    }
  },
  // invoice register
  invoiceFactoring: {
    introFactoringData: 'Introducir datos de factoring',
    requiredFields: '(*) Campos obligatorios',
    general: 'Entidad factoring (Cesionario)',
    registration: 'Información de registro',
    payment: {
      title: 'Datos de pago'
    },
    transferReferences: {
      title: 'Referencias de la cesión',
      clausuleLabel: 'Texto de la cláusula de cesión'
    },
    transferDocuments: {
      title: 'Documentos de la cesión',
      headers: {
        documentNature: 'N. del documento',
        representationType: 'T. de representación',
        documentType: 'T. de documento',
        newDocument: 'Nuevo documento de cesión'
      },
      form: {
        documentNature: 'Naturaleza del documento',
        representationType: 'Tipo de representación',
        documentType: 'Tipo de documento',
        repository: 'Repositorio electrónico',
        repositoryName: 'Nombre del repositorio',
        repositoryNameTooltip: '[CGN] Consejo General del Notariado, [ROLECE] Registro Oficial de Licitadores y Empresas Clasificadas del Estado, [REA] Registro Electrónico de Apoderamiento, [otros]',
        url: 'URL',
        reference: 'Referencia electrónica'
      }
    },
    paymentData: {
      title: 'Datos de pago',
      headers: {
        paymentDate: 'Fecha',
        amount: 'Importe',
        paymentMethod: 'Medio de pago',
        newPayment: 'Nuevo pago'
      },
      form: {
        paymentDate: 'Fecha del pago',
        amount: 'Importe',
        paymentMethod: 'Medio de pago',
        accountType: 'Cuenta',
        ibanCredited: 'IBAN Abono',
        ibanDebited: 'IBAN Cargo'
      }
    }
  }
}
